const initialData = {
  isLoading: false,
  passportsData: [],
  passportData: {},
  ticketsData: [],
};

export default function admin(state = initialData, action) {
  switch (action.type) {
    case "GET_PASSPORTS_REQUEST":
      return {
        ...state,
        isLoading: true,
      };
    case "GET_PASSPORTS_SUCCESS":
      return {
        ...state,
        passportsData: action.payload.data,
        ticketsData: action.payload.tickets,
        isLoading: false,
      };
    case "GET_PASSPORTS_FAILED":
      return {
        ...state,
        passportsData: [],
        isLoading: false,
      };

    case "CREATE_PASSPORT_REQUEST":
      return {
        ...state,
        isLoading: true,
      };
    case "CREATE_PASSPORT_SUCCESS":
      return {
        ...state,
        passportData: action.payload.data,
        isLoading: false,
      };
    case "CREATE_PASSPORT_FAILED":
      return {
        ...state,
        passportData: {},
        isLoading: false,
      };

    case "UPDATE_PASSPORT_REQUEST":
      return {
        ...state,
        isLoading: true,
      };
    case "UPDATE_PASSPORT_SUCCESS":
      return {
        ...state,
        passportData: action.payload.data,
        isLoading: false,
      };
    case "UPDATE_PASSPORT_FAILED":
      return {
        ...state,
        passportData: {},
        isLoading: false,
      };

    case "DELETE_PASSPORT_REQUEST":
      return {
        ...state,
        isLoading: true,
      };
    case "DELETE_PASSPORT_SUCCESS":
      return {
        ...state,
        passportData: action.payload.data,
        isLoading: false,
      };
    case "DELETE_PASSPORT_FAILED":
      return {
        ...state,
        passportData: {},
        isLoading: false,
      };

    default:
      return {
        ...state,
      };
  }
}
